<template>
  <body class="ui_game_spot_difference">
    <div class="row gamepage_header">
      <img class="gamepage_logo" src="static/images/logo-spot-difference.png"/>
      <h1>{{ getTranslations.home_game_sd_game }}</h1>
      <p>{{ getTranslations.home_game_sd_which_photo }}</p>
      <p>{{ getTranslations.home_game_sd_choose_carefully }}</p>
    </div>
    <div class="row gamepage_timmer">
      <div class="game-timer__prog">
        <div class="game-timer__prog__inner " :style="progressBar"></div>
      </div>

    </div>
    <div class="row gamepage_game">

      <div class="col-6 gamepage_game_image show_card" v-for="(icon, index) in personalizedData"
           @click="sendAnswer(index)"
           :style="disableDiv"
           :key="index+1" :ref="index+1">
        <img class="spot_image_single" :src=icon.url />
      </div>

    </div>

    <component :is="modalForHomePage"></component>

  </body>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import TimeIsUp from '@/components/home/modals/TimeIsUp';
import PostGame from '@/components/home/modals/PostGame';
import WrongAnswer from '@/components/home/modals/WrongAnswer';
import webSocket from '@/common/webSocket';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin, GameMixin2 } from '@/common/mixins/game';
import modals from '../../../common/modals';

export default {
  name: 'spotDifference',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin, GameMixin2],
  data() {
    return {
      progressBarWidth: 0.0,
      showedSpinModal: false,
      timeIsUp: false,
      showedModal: false,
      userLevel: 0,
      bonusPoints: 0,
      gamesEarned: 0,
      personalizedData: null,
      availableAnswers: [],
      secondsElapsed: 0,
      timer: null,
      timer1: null,
      indexToHideCards: 1,
      stompClient: null,
      subscription: null,
      buttonPushed: false,
    };
  },
  created() {
    console.log('in Game created hook');
    this.stompClient = webSocket.getGameStompClient();
    console.log('this.stompClient:', this.stompClient);
    this.initQuestionData();
    this.startSubscriptionChannel();
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
    this.subscription.unsubscribe();
    this.resetGameState();
    this.stopTimer();
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
      'isGamePageFlow',
      'updateGameType',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    stompFailure(error) {
      console.log(error);
      window.location.reload();
    },
    initAndStartTimer() {
      clearInterval(this.timer);
      this.onlyOneCicle = true;
      this.secondsElapsed = 0;
      /* eslint-disable */
      this.$nextTick(() => {
        this.timer = setInterval(() => {
          this.secondsElapsed += 1;
          this.progressBarWidth += (100 * 500) / this.roundTimeList[2];
          if ((this.secondsElapsed * 1000 / 2) === this.roundTimeList[2]) {
            this.progressBarWidth = 100.0;
            this.timeIsUp = true;
            clearInterval(this.timer);
          }
        }, 500);
      });
      /* eslint-enable */
    },
    stopTimer() {
      this.progressBarWidth = 0.0;
      clearInterval(this.timer);
    },
    initQuestionData() {
      console.log('initializing question data...');
      this.updateGameType('SD');
      this.isGamePageFlow(true);
      this.personalizedData = this.shuffledCardDTOS;
      console.log('this.personalizedData:', this.personalizedData);
      this.normalTransition = false;
      this.timeIsUp = false;
      console.log('calling initAndStartTimer()...');
      this.initAndStartTimer();
    },
    startSubscriptionChannel() {
      console.info(`Subscribing to channel: /topic/finishedGame/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/finishedGame/${this.gameID}`, (response) => {
        console.log('[Game] Inside ctaSelected response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        console.log(responseBody);
        const gameFinished = responseBody.gameDTO.won;
        if (gameFinished === false) { // time is up
          console.log('Time is up. Display Pop Up');
          this.storeModalForHomePage(TimeIsUp);
          this.normalTransition = true;
          modals.showHideModalForGameNotificationPage(this);
        }
      });
    },
    sendAnswer(answerIndex) {
      console.log('--> inside sendAnswer....');
      console.log('Card Index:', answerIndex);
      this.buttonPushed = true;
      // eslint-disable-next-line
      $("#container").html("");
      console.log('sending player answer');
      return this.$axios({
        url: `api/sendAnswer?gameId=${this.gameID}&answerIndex=${answerIndex}`,
        method: 'GET',
        headers: {
          Authorization: this.jwtInVuex,
        },
      }).then((response) => {
        console.log('inside sendAnswer');
        clearInterval(this.timer);
        this.normalTransition = true;
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          const responseData = response.data.data;
          this.storeTIPostGameData(responseData);
          const index = answerIndex + 1;
          if (responseData.status === 'FAILED') {
            this.storeModalForHomePage(WrongAnswer);
            this.failAnimationForIndexes(index);
          } else if (responseData.status === 'USER_WON') {
            console.log('User made to complete game');
            this.storeModalForHomePage(PostGame);
            this.successAnimationForIndexes(index);
          }
        }
      }).catch((error) => {
        console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
      });
    },
    failAnimationForIndexes(lastChoice) {
      console.log(this.$refs);
      this.$refs[lastChoice][0].classList.add('fail_card');
      setTimeout(() => {
        modals.showHideModalForGameNotificationPage(this);
      }, 1000);
    },
    successAnimationForIndexes(lastChoice) {
      // if response correct
      this.$refs[lastChoice][0].classList.add('success_card');
      setTimeout(() => {
        this.$refs[lastChoice][0].classList.add('success_animation');
      }, 1000);
      setTimeout(() => {
        modals.showHideModalForGameNotificationPage(this);
      }, 2000);
    },
    updateNormalTransitionAndStartNewGame() {
      console.log('New Game button of post game pop up clicked');
      this.normalTransition = true;
      this.$router.push('/searchingOpponent');
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'timeRoundIntro',
      'roundTimeList',
      'modalForHomePage',
    ]),
    ...mapState('game', [
      'gameType',
      'shuffledCardDTOS',
      'gameCardDTOS',
      'spinWheelInfo',
      'gameID',
      'playersDetails',
      'userLeveledUp',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    progressBar() {
      return {
        width: `${this.progressBarWidth}%`,
      };
    },
    disableDiv() {
      return (!this.timeIsUp && !this.buttonPushed) ? 'cursor:pointer' : 'pointer-events:none';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/SpotDifference.vue